@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.innerContent {
  @include breakpoints.desktop {
    max-width: 961px;
    min-width: 961px;
    width: 961px;
    margin: 0 auto;
  }
}
.greeting {
    height: 70px;
    margin-top: 20px;
    margin-left: 20px;
    font-family: typography.$font-serif;
    font-size: 24px;
    font-weight: 400;
}

.inlineLink {
    @include typography.body-semibold-link;
    border: none;
    text-decoration: underline;
    text-underline-offset: 2px;
  
    &:hover {
      border: none;
      color: var(--highlight-blue);
    }
  }
.orderNotFound {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    text-align: center;
}